import Utilities from "./utilities";
import Agency from "./agency";
import Stop from "./stop";

let $routePanel,
	$routePanelName,
	$routePanelBtn,
	$routePanelStops,
	$routePanelAlert,
	$routeDetailButtons;

const Route = {
	init: async ( tm ) => {
		return new Promise( resolve => {
			$routePanel = document.getElementById( 'tab-bus_routes' ).querySelector( '.tm__panel--route_detail' );
			$routePanelName = $routePanel.querySelector( 'h3' );
			$routePanelBtn = $routePanel.querySelector( '.button' );
			$routePanelStops = $routePanel.querySelector( '.tm__stops' );
			$routePanelAlert = $routePanel.querySelector( '.tm__route-alert-link' );
			if ( !$routeDetailButtons ) $routeDetailButtons = Route.getRouteDetailButtons();

			// add the geojson route features and set the bounds after completion
			let url = tmVars.gtfsDir + 'geojson/routes.geojson';
			Utilities.cachedFetch( url ).then( ( response ) => {
				return response.ok ? response.json() : Promise.reject( response );
			} ).then( ( data ) => {
				tm.map.data.addListener( 'addfeature', Route.saveRouteBounds );
				tm.map.data.addListener( 'click', ( e ) => Route.routeClickedInMap( e, tm ) );
				tm.map.data.addListener( 'mouseover', ( e ) => Route.routeHoveredInMap( e, tm, true ) );
				tm.map.data.addListener( 'mouseout', ( e ) => Route.routeHoveredInMap( e, tm, false ) );
				Utilities.initMapZoom( tm, tm.map.data.addGeoJson( data ) );
				Route.updateRouteColors( tm );

				[...$routeDetailButtons].forEach( ( $btn ) => {
					$btn.addEventListener( 'mouseover', ( e ) => Route.routeHoveredInRoutePanel( e, tm, true ) );
					$btn.addEventListener( 'mouseout', ( e ) => Route.routeHoveredInRoutePanel( e, tm, false ) );
				} );

				resolve();
			} ).catch( ( err ) => {
				console.error( 'Error:', err );
				resolve();
			} );
		} );
	},

	getRouteDetailButtons: () => {
		return document.getElementById( 'tab-bus_routes' )
			.querySelector( '.tm__panel--agency_detail' )
			.querySelectorAll( 'button[data-open-panel="route_detail"]' );
	},

	updateBackButton: ( tm ) => {
		const $btn = $routePanel.querySelector( '.tm__back' );
		$btn.dataset.openPane = 'agency|' + tm.visible.agencyId;
	},

	updateRouteColors: ( tm ) => {
		tm.map.data.setStyle( ( feature ) => {
			let color = tm.visible.agencyId
				? 'route_' + feature.getProperty( 'route_id' )
				: 'agency_' + feature.getProperty( 'agency_id' );
			return {
				strokeColor: Utilities.getStrokeColor( color ),
				strokeWeight: 6
			};
		} );
	},

	routeHoveredInMap: ( e, tm, mouseover = false ) => {
		// hovered a route while in the agency detail view: highlight that specific route
		if ( tm.visible.agencyId ) {
			if ( !tm.visible.routeId ) {
				// (don't do anything if you hover a route after you've already selected that route)
				tm.map.data.overrideStyle( e.feature, Route.getRouteHoverStyle( mouseover ) );
			}
			return true;
		}

		// hovered a route while in the bus route overview: highlight all routes from that agency
		let agencyId = parseInt( e.feature.getProperty( 'agency_id' ), 10 );
		tm.map.data.forEach( function ( feature ) {
			if ( feature.getProperty( 'agency_id' ) === agencyId ) {
				tm.map.data.overrideStyle( feature, Route.getRouteHoverStyle( mouseover ) );
			}
		} );
	},

	routeHoveredInRoutePanel: ( e, tm, mouseover = false ) => {
		const pane = e.target.dataset.openPane.split( '|' );
		if ( !pane ) return;

		const routeId = parseInt( pane[1], 10 );
		if ( !routeId ) return;

		tm.map.data.forEach( function ( feature ) {
			if ( feature.getProperty( 'route_id' ) === routeId ) {
				tm.map.data.overrideStyle( feature, Route.getRouteHoverStyle( mouseover ) );
			}
		} );
	},

	getRouteHoverStyle: ( mouseover ) => {
		return {
			zIndex: mouseover ? 1 : 0,
			strokeWeight: mouseover ? 7 : 6
		}
	},

	openPanelRouteDetail: ( tm, routeId, routeName ) => {
		Stop.updateVisibleStop( tm, null );
		Stop.revertStopStyling( tm );
		Stop.closeStopInfowindow();
		Route.updateBackButton( tm );

		if ( tm.visible.routeId !== routeId ) {
			Route.updateVisibleRoute( tm, routeId, routeName );
			Route.renderPaneRouteDetail( tm );
		}

		Route.showRouteAndStops( tm );
	},

	saveRouteBounds: ( e ) => {
		let featureBounds = new google.maps.LatLngBounds(),
			geometry = e.feature.getGeometry();

		if ( !(geometry instanceof google.maps.Data.Point) ) {
			geometry.getArray().forEach( ( g ) => {
				g.forEachLatLng( ( latlng ) => featureBounds.extend( latlng ) );
			} );
		}

		e.feature.setProperty( 'bounds', featureBounds );
	},

	routeClickedInMap: ( e, tm ) => {
		// undo any hover effects
		Route.routeHoveredInMap( e, tm, false )

		if ( tm.visible.agencyId ) {
			if ( !tm.visible.routeId ) {
				// already zoomed into an agency: clicking should zoom to the route and not to the agency
				Route.openRouteWhenRouteClickedInMap( e, tm );
			}
		} else {
			// if not zoomed into an agency yet, clicking should zoom to the agency and not to the route
			Route.openAgencyWhenRouteClickedInMap( e, tm );
		}

		return true;
	},

	openRouteWhenRouteClickedInMap: ( e, tm ) => {
		let agencyId = parseInt( e.feature.getProperty( 'agency_id' ), 10 ),
			routeId = parseInt( e.feature.getProperty( 'route_id' ), 10 );
		if ( agencyId && routeId ) {
			let $button = tm.$sidebar.querySelector( '[data-open-pane="route|' + routeId + '"]' ),
				$panel = tm.$sidebar.querySelector( '[data-panel="agency_detail"]' );
			if ( $button && $panel ) {
				Agency.updateVisibleAgency( tm, agencyId );
				let $panes = $panel.querySelectorAll( '[data-pane]' );
				[...$panes].filter( ( el ) => {
					if ( el.matches( '[data-pane="agency|' + agencyId + '"]' ) ) {
						el.setAttribute( 'aria-hidden', 'false' );
						el.removeAttribute( 'inert' );
					} else {
						el.setAttribute( 'aria-hidden', 'true' );
						el.setAttribute( 'inert', '' );
					}
				} );
				$button.click();
			}
		}
	},

	openAgencyWhenRouteClickedInMap: ( e, tm ) => {
		let agencyId = parseInt( e.feature.getProperty( 'agency_id' ), 10 );
		if ( agencyId ) {
			let $button = tm.$sidebar.querySelector( '[data-open-pane="agency|' + agencyId + '"]' );
			if ( $button ) {
				Agency.updateVisibleAgency( tm, agencyId );
				$button.click();
			}
		}
	},

	maybeLoadRouteAlertLink: ( tm ) => {
		let $button = tm.$sidebar.querySelector( '[data-open-pane="route-alerts|' + tm.visible.routeId + '"]' );
		const $alertButton = document.createElement( 'button' );

		$alertButton.type = 'button';
		$alertButton.textContent = 'View Alert';
		$alertButton.addEventListener( 'click', () => {
			const eventTab = new CustomEvent( 'tm__change-tab', {detail: {oldIndex: 0, newIndex: 2, dontPushHistory: true}} );
			tm.$sidebar.dispatchEvent( eventTab );

			const eventPanelDetail = {
					section: 'tab-alerts',
					panel: 'alert_detail',
					pane: 'route-alerts|' + tm.visible.routeId,
					transition: false
				},
				eventPanel = new CustomEvent( 'tm__panel-button-clicked', {detail: eventPanelDetail} );
			tm.$sidebar.dispatchEvent( eventPanel );
		} );

		$routePanelAlert.innerHTML = '';
		if ( $button ) {
			$routePanelAlert.appendChild( $alertButton );
		}
	},

	showRouteAndStops: ( tm ) => {
		tm.map.data.forEach( ( feature ) => {
			// hide all route features except the desired visible route
			if ( tm.visible.routeId !== feature.getProperty( 'route_id' ) ) {
				tm.map.data.overrideStyle( feature, {visible: false} );
				return;
			}

			// show visible route
			tm.map.data.overrideStyle( feature, {visible: true} );

			// include this feature in the zoom bounds
			let bounds = new google.maps.LatLngBounds();
			bounds.union( feature.getProperty( 'bounds' ) );
			Utilities.zoomToBounds( tm, bounds );

			// show stops from this route
			const agencyId = parseInt( feature.getProperty( 'agency_id' ), 10 );
			Agency.updateVisibleAgency( tm, agencyId ); // ensure this is set (if you click on the route on the map, it wouldn't be)

			// necessary if you accessed the route directly instead of by clicking through an agency
			Agency.preloadAgencyStops( tm ).then( () => {
				tm.stopLayers[agencyId].revertStyle(); // reset any active stop
				tm.stopLayers[agencyId].setStyle( ( feature ) => {
					return {
						visible: (feature.getProperty( 'route' ) === tm.visible.routeId),
						title: feature.getProperty( 'name' ),
						icon: {
							path: 'M 10,5 A 5,5 0 0 1 5,10 5,5 0 0 1 0,5 5,5 0 0 1 5,0 5,5 0 0 1 10,5 Z',
							strokeWeight: 0,
							fillColor: Utilities.getMarkerColor( 'route_' + tm.visible.routeId ),
							fillOpacity: 1,
							scale: 1.6,
							anchor: new google.maps.Point( 5, 5 )
						}
					}
				} );
				tm.stopLayers[agencyId].setMap( tm.map );
			} );
		} );
	},

	renderPaneRouteDetail: async ( tm ) => {
		return new Promise( resolve => {
			if ( !tm.visible.routeId ) {
				console.warn( 'renderPaneRouteDetail no visible route' );
				resolve();
				return;
			}

			if ( !tm.visible.agencyId ) {
				console.warn( 'renderPaneRouteDetail no visible agency' );
				resolve();
				return;
			}

			$routePanelName.textContent = tm.visible.routeName;
			if ( $routePanelBtn ) $routePanelBtn.setAttribute( 'href', '/?route_id=' + tm.visible.routeId ); // custom query arg

			Route.maybeLoadRouteAlertLink( tm );

			let url = tmVars.gtfsDir + 'geojson/stops_' + tm.visible.agencyId + '.geojson';
			Utilities.cachedFetch( url ).then( ( response ) => {
				return response.ok ? response.json() : Promise.reject( response );
			} ).then( ( data ) => {
				let detailStops = '<ul class="tm__spaced-button-list" style="--route-color: ' + Utilities.getStrokeColor( 'route_' + tm.visible.routeId ) + '; --stop-color: ' + Utilities.getMarkerColor( 'route_' + tm.visible.routeId ) + '">';
				for ( const feature of data['features'] ) {
					if ( feature.properties.route !== tm.visible.routeId ) continue;
					detailStops += '<li><button data-open-pane="stop|' + feature.properties.stop + '">' + feature.properties.name + '</button></li>';
				}
				detailStops += '</ul>';
				$routePanelStops.innerHTML = detailStops;

				[...$routePanelStops.querySelectorAll( 'button' )].forEach( ( $btn ) => {
					$btn.addEventListener( 'mouseover', ( e ) => Stop.stopHoveredInRoutePanel( e, tm, true ) );
					$btn.addEventListener( 'mouseout', ( e ) => Stop.stopHoveredInRoutePanel( e, tm, false ) );
				} );
				resolve();
			} ).catch( ( err ) => {
				console.error( 'Error:', err );
				resolve();
			} );
		} );
	},

	updateVisibleRoute: ( tm, routeId, routeName = null ) => {
		routeId = parseInt( routeId, 10 );
		tm.visible.routeId = routeId ? routeId : null;
		tm.visible.routeName = routeName ? routeName : Route.getRouteName( routeId );
	},

	getRouteName: ( routeId ) => {
		if ( !routeId ) return null;
		if ( !$routeDetailButtons ) $routeDetailButtons = Route.getRouteDetailButtons();
		for ( const $button of $routeDetailButtons ) {
			if ( $button.dataset.openPane === 'route|' + routeId ) {
				return $button.textContent;
			}
		}
		return null;
	},
}

export default Route;
